import { JDSRatingBarItemProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSRatingBarItemProps>
  ): React.FC<JDSRatingBarItemProps & { internalIndex?: number }> =>
  (props: JDSRatingBarItemProps & { internalIndex?: number }) => {
    return (
      <Component
        {...{
          ...props,
          _role: props.type === 'interactive' ? 'radio' : undefined
        }}
        onHover={() => {
          props.onMouseEnter?.(props.internalIndex);
        }}
        onHoverEnd={() => {
          props.onMouseLeave?.(-1);
        }}
        onClick={() => {
          props.onClick?.(props.internalIndex);
        }}
        _updatedClipValue={
          props.clipValue !== undefined
            ? `${(
                (1 - Number(props.clipValue?.slice(0, -1)) / 100) *
                100
              ).toString()}%`
            : undefined
        }
      />
    );
  };
